import { ApiErrorResponse } from "@/@types/exception-list";
import { useCreateExceptionReportMutation } from "@/services/exception-list";
import { Button } from "components/ui/button";
import { toast } from "components/ui/use-toast";
import { useFiltersState } from "../../ducks/filters/hooks/state";
import SelectFilters from "./select-filters";


interface ModalEditExceptionProps {
  onCloseModal?: () => void;
}

export function ExportDialog({ onCloseModal }: ModalEditExceptionProps) {
  const { fromDate, toDate } = useFiltersState();

  const [generateReport, { isLoading }] = useCreateExceptionReportMutation();

  const handleGenerateReport = async () => {
    if (fromDate && toDate) {
      try {
        const result = await generateReport({
          params: {
            start_date: fromDate.toISOString().split("T")[0],
            final_date: toDate.toISOString().split("T")[0],
          },
        }).unwrap();

        const link = document.createElement("a");
        link.href = result.excelBase64;
        link.download = "relatório_de_exceções.xlsx";
        link.click();
        toast({
          variant: "success",
          description: "Relatório gerado com sucesso",
          duration: 5000,
        });
      } catch (error) {
        const err = error as { data: ApiErrorResponse };

        toast({
          variant: "destructive",
          description:
            err.data.messages?.[0] || "Erro inesperado ao gerar relatório.",
          duration: 5000,
        });
      }
    }
  };

  return (
    <div className="relative z-[9999] p-10 space-y-6 w-[600px] h-[300px] rounded-lg shadow-lg bg-white overflow-visible">
      <h2 className="text-xl font-semibold text-gray-800 border-b pb-2">
        Filtrar Relatório pela Data de Criação
      </h2>
      <SelectFilters />
      <div className="flex justify-end items-end gap-5 pt-5">
        <Button
          className="w-40 bg-transparent border border-gray-400 hover:bg-gray-100"
          onClick={() => onCloseModal?.()}
        >
          Fechar
        </Button>
        <Button
          className="w-40"
          onClick={handleGenerateReport}
          disabled={isLoading}
        >
          {isLoading ? "Gerando..." : "Gerar Relatório"}
        </Button>
      </div>
    </div>
  );
}